<script>
    import BrakTemplate from "./components/template/BrakTemplate.svelte";
    import LoginToken from "./components/page/LoginToken.svelte";
    import {currentPage} from "./stores.js";
    import {onMount, afterUpdate} from "svelte";

    onMount(() => {
        if ($currentPage === null) {
            currentPage.set(LoginToken);
        }
    });
    afterUpdate(() => window.dispatchEvent(new CustomEvent('currentPageChanged')))
</script>

<BrakTemplate>
    <svelte:component this={$currentPage} />
</BrakTemplate>

